const ITEMS = [
  "AI strategy builder", "Historical backtesting", "Paper trading simulator", "Live performance tracking",
  "SEBI-registered RA marketplace", "Portfolio & advisory", "NIFTY · BANKNIFTY · FINNIFTY",
  "Equity · Futures · Options", "Algo & API subscriptions",
];

export const Ticker = () => (
  <div className="border-y border-[var(--tn-line)] bg-[var(--tn-bg-2)] overflow-hidden py-4" data-testid="feature-ticker">
    <div className="flex w-max tn-marquee">
      {[0, 1].map((k) => (
        <ul key={k} className="flex shrink-0" aria-hidden={k === 1}>
          {ITEMS.map((i) => (
            <li key={i} className="flex items-center gap-3 px-6 font-mono text-[12px] uppercase tracking-wider text-[var(--tn-muted)] whitespace-nowrap">
              <span className="w-1 h-1 rounded-full bg-[var(--tn-cyan)]" />{i}
            </li>
          ))}
        </ul>
      ))}
    </div>
  </div>
);
